export default __webpack_public_path__ + "887d51e.png";